<div class="feedback" *ngIf="canViewWidget">
  <button
    df-button
    dfButtonType="clear"
    class="open-feedback open-feedback--widget color-ebony-a61"
    (click)="openZendeskWidget()"
    data-dgat="feedback-068"
    [disabled]="isInitializing"
    [class.is_disabled]="isInitializing"
    [attr.aria-label]="'Core_Help' | translate"
    df-button-square
    type="clear"
  >
    <df-spinner-button [isSpinning]="isInitializing">
      <df-icon
        class="mobile-only-icon-background"
        icon="question-mark-circle"
        size="large"
      ></df-icon>
    </df-spinner-button>
  </button>
</div>
